// Merges two arrays of primitives while removing any duplicate elements.
export const mergeTwoArraysRemovingDuplicates = (array1, array2) => {
    const combinedArray = [...new Set([...(array1 || []), ...(array2 || [])])];
    return combinedArray;
};
